<template lang="pug">
  button.reset-btn.button.button_download.button_icon-text(
    :class="'actions-panel__button btn-download ' + className"
    @click="downloadFile"
  ) {{text}}
</template>

<script>
import saveFile from '@/utils/saveFile'

export default {
  name: 'downloadFile',
  props: {
    text: String,
    className: String,
    url: String,
  },
  methods: {
    downloadFile() {
      this.$bar.start()
      this.$store
        .dispatch('downloadFile', {
          endpoint: this.url,
        })
        .then((r) => {
          this.$bar.finish()
          saveFile({
            blob: r.request.response,
            headers: r.headers,
          })
        })
        .catch((e) => {
          this.$bar.finish()
          this.$e.errorBox(e)
        })
    },
  },
}
</script>
